import { createRouter, createWebHistory } from 'vue-router'
import LoginView from '../views/LoginView.vue'
import DashboardView from '../views/DashboardView.vue'
import Landing from '@/views/landing.vue'

const routes = [
  {
    path: '',
    name: 'landing',
    component: Landing
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: DashboardView
  },
 
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
   scrollBehavior() {
    return { left: 0, top: 0 }
  }

})

export default router
